import { supabase } from '@/lib/supabase';
import type { VerifyAgreement } from '@/lib/database.types';

/** URL επαλήθευσης μιας συμφωνίας (για QR). Πάντα public web URL ώστε να ανοίγει σε browser χωρίς εφαρμογή. */
export function agreementVerifyUrl(id: string): string {
  const base = (process.env.EXPO_PUBLIC_VERIFY_BASE_URL ?? 'https://heirapsia.gr').replace(/\/+$/, '');
  return `${base}/landing-page/verify.html?id=${id}`;
}

/** Δημόσια επαλήθευση συμφωνίας (περιορισμένα στοιχεία, χωρίς auth). */
export async function verifyAgreement(id: string): Promise<VerifyAgreement | null> {
  const { data, error } = await supabase.rpc('verify_agreement', { p_id: id });
  if (error) throw error;
  return data?.[0] ?? null;
}
